import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/drop-zone-v2.0.0'
import v210 from '@nodes/dropzone-v2.1.0'

const dropZone = reactNode(
	'DropZone',
	{
		'v2.0.0': v200,
		'v2.1.0': v210,
	},
	{ docs: 'https://docs.rolder.app/#/dropzone', allowChildren: true }
)

import daV210 from '@nodes/dropzone-accept-v2.1.0'

const dropZoneAccept = reactNode(
	'DropZoneAccept',
	{
		'v2.1.0': daV210,
	},
	{ docs: 'https://docs.rolder.app/#/dropzone', allowChildren: true }
)

import drV210 from '@nodes/dropzone-reject-v2.1.0'

const dropZoneReject = reactNode(
	'DropZoneReject',
	{
		'v2.1.0': drV210,
	},
	{ docs: 'https://docs.rolder.app/#/dropzone', allowChildren: true }
)

import diV210 from '@nodes/dropzone-idle-v2.1.0'

const dropZoneIdle = reactNode(
	'DropZoneIdle',
	{
		'v2.1.0': diV210,
	},
	{ docs: 'https://docs.rolder.app/#/dropzone', allowChildren: true }
)

export { dropZone, dropZoneAccept, dropZoneReject, dropZoneIdle }
